import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import { IconButton, TextBox } from "../../Components/InputElements";
import Select from "react-select";
import { NoRecords } from "../../Components/Shimmer";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  currentDateAndTime,
  decodeData,
  formatDateWithTime,
  renderPages,
} from "../../Constants/constants";
import copy from "clipboard-copy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TooltipComponent from "../../Components/TooltipComponent";

class OfferLetterSentList extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      location_title: "",
      location_description: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      errors: [],
      email_preview: "",
      infoLoading: false,
      loadingSearch: false,
      isLetterModal: false,
      company_letter_title: "",
      company_letter_head_id: "",
      company_letter_content: "",
      markings: "",
      letterhead_url: "",
      emailList: false,
      email_next: false,
      email_prev: false,
      email_page: 1,
      email_limit: 10,
      email_total_records: 0,
      email_total_pages: 0,
      emailEdit: false,
      email_rows: [],
      mailTemplateTitle: "",
      mailSubject: "",
      mailBody: "",
      isEmailModal: "",
      resendEmail: "",
      selectedEmailTemplate: "",
      emailPreviewClicked: false,
      viewOfferLetterInfo: false,
      viewOfferLetterLogs: false,
      candidateRemarks :"",
      allowances: [],
      letter_rows: [],
      logs_details_rows: [],
      employee_name: "",
      candidateDesignation: "",
      candidateDepartment: "",
      candidateGrade: "",
      candidateLocation: "",
      employee_joining_date: "",
      loadingFilter: false,
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true,}, (prevState) => {
      this.GetList();
      this.getEmailTemplateList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  
  // componentDidUpdate(prevProps, prevState) {
  //   const { permissions } = this.context;
  //   console.log("permissions",permissions)
  //   if (permissions.length > 0 && prevState.decodedData === undefined) {
  //     const { encodedData } = this.state;
  
  //     const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
  
  //     this.setState(
  //       { decodedData });
  //   }
  // }

  GetList = () => {
    const { apiURL, apiHeaderJSON, permissions } = this.context;
    // console.log("permissions ==>>",permissions);
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetOfferLetterSendList`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingSearch: false,
            loadingFilter: false,
          });
        } else {
          this.setState({ loadingList: false, loadingSearch: false ,loadingFilter: false, });
        }
      })
      .catch((error) => {
        this.setState({ loadingList: false, loadingSearch: false,loadingFilter: false, });
      });
  };
  GetLogList = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetOfferLetterLogs?guest_employee_id=${id}`, {
        headers,
      })
      .then((response) => {
        var data = response.data;
        console.log("GetLogList", data);
        if (response.data.success === true) {
          this.setState({
            logs_details_rows: data,
            loadingList: false,
          },()=>{
            console.log("this.state.logs_details_rows?.salary_log_data[0]?.log_date",this.state.logs_details_rows?.salary_log_data[0]?.log_date);

          });
          
        } else {
          this.setState({ loadingList: false });
        }
      });
  };
  getEmailTemplateList = async () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}MailMaster/GetMailTemplateList`, {
        params: {
          limit: this.state.email_limit,
          page: this.state.email_page,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log(response?.data);
        if (response.data.success === true) {
          this.setState({
            email_rows: data?.response?.data,
            email_next: data?.response?.next ?? false,
            email_prev: data?.response?.prev ?? false,
            email_page: data?.response?.page ? data?.response?.page : 1,
            email_total_records: data?.response?.total_records
              ? data?.response?.total_records
              : 0,
            email_total_pages: data?.response?.total_pages
              ? data?.response?.total_pages
              : 0,
            loadingList: false,
          });
        } else {
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };

  getInfo = (id, idx) => {
    this.setState({
      infoLoading: false,
      emailList: id,
      isEmailModal: `${idx}`,
      mailTemplateTitle: this.state.email_rows[idx]?.mail_template_title,
      mailSubject: this.state.email_rows[idx]?.mail_subject,
      mailBody: this.state.email_rows[idx]?.mail_body,
    });
  };
  getEmailInfo = (id, idx) => {
    this.setState({
      infoLoading: false,
      emailList: id,
      isEmailModal: `${idx}`,
      mailTemplateTitle:
        this.state.logs_details_rows?.employee_mail_details[idx]
          ?.mail_template_title,
      mailSubject:
        this.state.logs_details_rows?.employee_mail_details[idx]?.email_subject,
      mailBody:
        this.state.logs_details_rows?.employee_mail_details[idx]
          ?.employee_mail_content,
    });
  };

  // renderPages(company_letter_content, letterhead_url, markings) {
  //   // const { company_letter_content, letterhead_url, markings } = this.state;
  //   const pageHeight = 297;
  //   const marginTop = parseInt(markings.split(",")[0] || 0, 10);
  //   const marginBottom = parseInt(markings.split(",")[1] || 0, 10);
  //   const marginLeft = parseInt(markings.split(",")[3] || 0, 10);
  //   const marginRight = parseInt(markings.split(",")[2] || 0, 10);

  //   const contentHeight = pageHeight - marginTop - marginBottom;

  //   const tempDiv = document.createElement("div");
  //   tempDiv.style.position = "absolute";
  //   tempDiv.style.width = "210mm";
  //   tempDiv.style.visibility = "hidden";
  //   tempDiv.style.fontSize = "14px";
  //   tempDiv.innerHTML = company_letter_content;

  //   document.body.appendChild(tempDiv);

  //   const pages = [];
  //   let currentPage = "";
  //   let totalHeight = 0;

  //   Array.from(tempDiv.childNodes).forEach((node) => {
  //     const clone = node.cloneNode(true);
  //     tempDiv.innerHTML = "";
  //     tempDiv.appendChild(clone);

  //     const nodeHeight = tempDiv.scrollHeight / 3.77953;
  //     totalHeight += nodeHeight;

  //     if (totalHeight <= contentHeight) {
  //       currentPage += node.outerHTML;
  //     } else {
  //       pages.push(currentPage);
  //       currentPage = node.outerHTML;
  //       totalHeight = nodeHeight;
  //     }
  //   });

  //   if (currentPage) pages.push(currentPage);

  //   document.body.removeChild(tempDiv);

  //   return pages.map((pageContent, index) => (
  //     <div
  //       key={index}
  //       className="bubble-editor"
  //       style={{
  //         position: "relative",
  //         // width: "210mm",
  //         height: `${pageHeight}mm`,
  //         // marginTop: `${marginTop}mm`,
  //         // marginBottom: `${marginBottom}mm`,
  //         border: "1px solid #F3F3F9",
  //       }}
  //     >
  //       {letterhead_url && (
  //         <img
  //           src={letterhead_url}
  //           alt="Letterhead"
  //           style={{ position: "absolute", width: "100%", height: "297mm" }}
  //         />
  //       )}
  //       <div
  //         dangerouslySetInnerHTML={{ __html: pageContent }}
  //         style={{
  //           position: "relative",
  //           paddingTop: `${marginTop}mm`,
  //           paddingBottom: `${marginBottom}mm`,
  //           paddingLeft: `${marginLeft}mm`,
  //           paddingRight: `${marginRight}mm`,
  //           boxSizing: "border-box",
  //           background: "transparent",
  //         }}
  //       />
  //     </div>
  //   ));
  // }
 
  GetLetterInfo = (idx) => {
    // console.log(`this.state.logs_details_rows?.employee_letter_details[idx]`,this.state.logs_details_rows?.employee_letter_details[idx])
    this.setState({
      company_letter_title:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.company_letter_title,
      company_letter_head_id:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.company_letter_head_id,
      company_letter_content:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.employee_letter_content,
      markings:
        this.state.logs_details_rows?.employee_letter_details[idx]?.markings ||
        "0,0,0,0",
      letterhead_url:
        this.state.logs_details_rows?.employee_letter_details[idx]
          ?.letterhead_url || null,
      isLetterModal: `${idx}`,
    });
  };
  handleCopyClick = (code) => {
    copy(code);
    toast.success(`Code Has Been Copied! ${code}`, { autoClose: 1500 });
  };
  handleEditorEmailChange = (event, editor) => {
    // const value = event.target.value;

    // Clear the previous timeout if the user is still typing
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timeout to call the function after 1 second
    this.debounceTimer = setTimeout(() => {
      const mailBody = editor.getData();
      // Clear the error for the mailBody field
      const errorsList = { ...this.state.errors };
      delete errorsList.mailBody;

      this.setState({
        mailBody: mailBody,
        errors: errorsList, // Update errors object
      });
    }, 1000);
  };
  handleEmail = () => {
    const temp = [...this.state.email_rows]; // Create a shallow copy of the array

    const index = parseInt(this.state.isEmailModal); // Index of the element to update
    if (index >= 0 && index < temp.length) {
      // Update the specific element at the given index
      temp[index] = {
        ...temp[index],
        mail_body: this.state.mailBody,
        mail_template_title: this.state.mailTemplateTitle,
        mail_subject: this.state.mailSubject,
      };
    }

    // Debugging: Log the updated value for verification
    console.log("Updated element:", temp[index]);

    // Update the state with the modified array
    this.setState({ email_rows: temp, emailEdit: false }, () =>
      console.log("Updated email_rows:", this.state.email_rows)
    );
  };

  templatePreview = (templateType) => {
    const replaceCheatCodeList = [
      {
        cheat_code: "##current_date##",
        value: formatDateWithTime()?.split(" ")[0],
      },
      { cheat_code: "##employee_name##", value: this.state.employee_name },
      {
        cheat_code: "##department_title##",
        value: this.state.candidateDepartment,
      },
      {
        cheat_code: "##designation_title##",
        value: this.state.candidateDesignation,
      },
      { cheat_code: "##grade_title##", value: this.state.candidateGrade },
      { cheat_code: "##location_title##", value: this.state.candidateLocation },
      {
        cheat_code: "##employee_joining_date##",
        value: formatDateWithTime(this.state.employee_joining_date)?.split(
          " "
        )[0],
      },
    ];
    // if(templateType === "letter"){
    //   let letter=this.previewTemplate(this.state.company_letter_content,replaceCheatCodeList);
    //   this.setState({letter_preview:letter});
    // }
    console.log(" this.state.employee_name preview:", this.state.employee_name);
    if (templateType === "email") {
      let email = this.previewTemplate(
        this.state.mailBody,
        replaceCheatCodeList
      );
      console.log(" email preview:", email);

      this.setState({ email_preview: email });
    }
  };

  previewTemplate = (inputString, cheatCodeArray) => {
    if (!inputString || !cheatCodeArray || !Array.isArray(cheatCodeArray)) {
      throw new Error(
        "Invalid input: Provide a valid string and cheatCodeArray"
      );
    }

    return cheatCodeArray.reduce((updatedString, { cheat_code, value }) => {
      if (cheat_code && value) {
        const regex = new RegExp(cheat_code, "g"); // Use 'g' flag for global replacement
        return updatedString.replace(regex, value);
      }
      return updatedString;
    }, inputString);
  };

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployee`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${
                response.data.success === true ? "Success" : "Failed"
              }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  handleCancelEmail = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    const emails = this.state.email_rows.filter((val) => {
      if (this.state.selectedEmailTemplate == val?.mail_template_id) {
        return val;
      }
    });
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to send Email?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No!",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ loadingCancelEmail: true });
        const data = {
          email_template: emails,
          date: currentDateAndTime(),
        };
        console.log(data);
        axios
          .post(`${apiURL}Employees/CancelOfferLetter`, data, {
            params: {
              guest_employee_id: id,
            },
            headers,
          })
          .then((response) => {
            const { success } = response.data;
            console.log("handleToggleSwitch ~ response =======>>>", response);
            if (success === true) {
              this.setState({
                resendEmail: false,
                selectedEmailTemplate: "",
                emailEdit: false,
                emailPreviewClicked: false,
                emailList: false,
                loadingCancelEmail: true,
              });
              this.GetList();
              this.GetLogList();
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
            } else {
              this.setState({
                loadingCancelEmail: true,
              });
              Swal.fire({
                title: `<strong>${
                  response.data.success === true ? "Success" : "Failed"
                }</strong>`,
                text: response.data.message,
                icon: response.data.success === true ? "success" : "error",
                showConfirmButton: true,
                allowOutsideClick: false,
              });
            }
          })
          .catch((error) => {
            this.setState({
              loadingCancelEmail: true,
            });
            Swal.fire({
              title: `<strong>Failed</strong>`,
              text: error?.response?.data?.message,
              icon: "error",
              showConfirmButton: true,
              allowOutsideClick: false,
            });
          });
      }
    });
  };

  handleInputSearch = (e) => {
    this.setState({ loadingSearch: true }, () => {
      this.GetList();
    });
  };

  handleFilterSearch = (e) => {
    // this.setState({ loadingSearch: true }, () => {
      this.GetList();
    // });
  };

  handleEmailInputChange = (e) => {
    const { name, value } = e.target;

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  handleInputChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (this.state.keyword === "") {
          this.GetList();
        }
      }
    );
  };
  handleDateChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSelectChange = (selectedOption) => {
    this.setState({ selectOption: selectedOption });
  };

  handleClearAll = () => {
    this.setState(
      {
        employee_id: 0,
        location_title: "",
        location_description: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
        keyword: "",
        from_date: "",
        to_date: "",
        selectOption: "",
      },
      () => {
        this.GetList();
      }
    );
  };

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };

  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
        }
      );
    }
  };

  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };

  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Offer Letter Issued List`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header ">
                    <div className="row col-md-12">
                      <div className="col-md-3">
                        <label htmlFor="keyword">Candidate Name</label>
                        <div className="input-group">
                          <input
                            type="search"
                            className="form-control"
                            onChange={this.handleInputChange}
                            name="keyword"
                            value={this.state.keyword}
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder="Search Name"
                          />

                          <button
                            className="btn btn-success"
                            onClick={()=>{ 
                              if(this.state.keyword && !this.state.loadingSearch){
                                this.handleInputSearch()
                              }
                            }}
                            type="button"
                            
                            id="button-addon2"
                          >
                            {this.state.loadingSearch ? (
                              <span
                                class="spinner-border flex-shrink-0"
                                role="status"
                                style={{
                                  width: "0.8rem",
                                  height: "0.8rem",
                                  borderWidth: "2px",
                                }}
                              >
                                <span class="visually-hidden">Loading...</span>
                              </span>
                            ) : (
                              <i className="ri-search-line"></i>
                            )}
                          </button>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <TextBox
                          type="Date"
                          id="from_date"
                          name="from_date"
                          label="Offer Sent From Date"
                          value={this.state.from_date}
                          change={this.handleDateChange}
                        />
                      </div>
                      <div className="col-md-3">
                        <TextBox
                          type="Date"
                          id="to_date"
                          name="to_date"
                          label="Offer Sent To Date"
                          value={this.state.to_date}
                          change={this.handleDateChange}
                        />
                      </div>
                      
                      <div style={{ width: "11%" }} className="col-md-2 ">
                        <div>
                          <label>Apply Filter</label>
                        </div>
                        {this.state.loadingFilter === "1" ? (
                          <button className="btn btn-info btn-load">
                            <span className="d-flex align-items-center">
                              <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </span>
                              <span className="flex-grow-1 ms-2">
                                Loading...
                              </span>
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={() => {
                              this.setState(
                                {
                                  loadingFilter: "1",
                                },
                                () => {
                                  this.handleInputSearch();
                                  console.log(
                                    "this.state.loadingFilter1 ==>",
                                    this.state.loadingFilter
                                  );
                                }
                              );

                              // console.log("this.state.loadingFilter ==>" + this.state.loadingFilter);
                            }}
                            className={`w-100 btn btn-info btn-label waves-effect waves-light ${
                              !this.state.keyword &&
                              this.state.from_date === "" &&
                              this.state.to_date === "" &&
                              this.state.selectOption === "" &&
                              !this.state.filter_leave_type_id
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                            Filter
                          </button>
                        )}
                      </div>

                      <div style={{ width: "11%" }} className="col-md-3">
                        <div>
                          <label>Clear Filter</label>
                        </div>
                        {this.state.loadingFilter === "2" ? (
                          <button className="btn btn-secondary btn-load">
                            <span className="d-flex align-items-center">
                              <span
                                className="spinner-border flex-shrink-0"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </span>
                              <span className="flex-grow-1 ms-2">
                                Loading...
                              </span>
                            </span>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className={`btn w-100 noWrap btn-secondary btn-label waves-effect waves-light ${
                              !this.state.keyword &&
                              this.state.from_date === "" &&
                              this.state.selectOption === "" &&
                              this.state.to_date === "" &&
                              !this.state.filter_leave_type_id
                                ? "disabled"
                                : ""
                            }`}
                            onClick={() => {
                              this.setState({ loadingFilter: "2" }, () => {
                                this.handleClearAll();
                                console.log(
                                  "this.state.loadingFilter1 ==>",
                                  this.state.loadingFilter
                                );
                              });
                            }}
                          >
                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 noWrap"></i>{" "}
                            Clear
                          </button>
                        )}
                      </div>
                      {/* <div className='col-md-3'>
                            <div>
                            <label>Show All </label>
                            </div>
                            <button
                            type="button"
                            className={`btn btn-secondary noWrap btn-sm btn-label right ms-auto ${(!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption) ? 'disabled' : ''}`}
                            onClick={this.handleClearAll}
                            disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption}
                            >
                            <i className=" ri-database-2-line label-icon align-middle fs-16 ms-2"></i> Show All
                            </button>
                        </div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-stripped`}>
                      <thead className="table-light">
                        <tr>
                          <th>Issued Date</th>
                          <th>Contact No.</th>
                          <th>Candidate Name</th>
                          <th>Personal Email</th>
                          <th>Location</th>
                          <th>Department</th>
                          <th>Offer Status</th>
                          {(this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3)) && (
                            <th className="text-center">Action</th>)}
                        </tr>
                      </thead>
                      {this.state.rows.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={11}>
                              <NoRecords />
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody>
                          {this.state.rows.map((row) => {
                            return (
                              <tr key={row?.guest_employee_id}>
                                <td>
                                  {row?.sent_date
                                    ? formatDateWithTime(row?.sent_date)
                                    : "--"}
                                </td>
                                <td>{row?.employee_mobile_number}</td>
                                <td>{row?.employee_name}</td>
                                {/* <td>
                                  <NavLink to={`/Profile/${row?.guest_employee_id}`}>
                                    {row?.employee_name}
                                  </NavLink>
                                </td> */}
                                <td>{row?.employee_email_address || "--"}</td>
                                <td>{row?.location_title}</td>
                                <td>{row?.department_title}</td>
                                <td>
                                  {" "}
                                  <div
                                    style={{ fontSize: "0.65rem" }}
                                    className={` bg-${row?.offer_status_classes} fw-semibold px-1 text-center py-1 text-white rounded-4`}
                                  >
                                    {row?.offer_status}
                                  </div>{" "}
                                </td>
                                {(this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3)) && (
                                <td className="d-flex justify-content-around  gap-2">
                                  {/* <button
                                    onClick={() => this.setState({ viewOfferLetterInfo: row?.guest_employee_id })} 
                                    className="btn-icon btn btn-sm btn-outline-danger"
                                  >
                                    <i className="ri-mail-close-line"></i>
                                  </button> */}
                                  {/* <TooltipComponent name="View Offer Letter Logs" position="bottom">
                                  <button
                                   
                                    type="button"
                                    className="btn-icon btn btn-sm btn-outline-success"
                                  >
                                    {this.state.loadingList ? (
                                      <span
                                        class="spinner-border flex-shrink-0"
                                        role="status"
                                        style={{
                                          width: "0.8rem",
                                          height: "0.8rem",
                                          borderWidth: "2px",
                                        }}
                                      >
                                        <span class="visually-hidden">
                                          Loading...
                                        </span>
                                      </span>
                                    ) : (
                                      <i className="ri-file-info-line"></i>
                                    )}
                                  </button>
                                  </TooltipComponent> */}
                                  { this.state.decodedData?.includes(1) && (
                                  <IconButton 
                                    loading={this.state.loadingList }
                                    onClick={() => {
                                      this.setState(
                                        {
                                          viewOfferLetterLogs: `${row?.guest_employee_id}`,
                                          candidateRemarks: row?.employee_letter_remark,
                                          loadingList: true,
                                          employee_name: row?.employee_name,
                                          candidateDesignation:
                                            row?.designation_title,
                                          candidateDepartment:
                                            row?.department_title,
                                          candidateGrade: row?.grade_title,
                                          candidateLocation:
                                            row?.location_title,
                                          employee_joining_date:
                                            row?.employee_joining_date,
                                        },
                                        () => {
                                          this.GetLogList(
                                            row?.guest_employee_id
                                          );
                                        }
                                      )
                                    }} type='success' icon='ri-file-info-line' tooltipName='View Offer Letter Logs' tooltipPosition='bottom' />
                                  )}

                                  {/* <TooltipComponent name="Send Offer Cancelation Email" position="bottom">
                                  <button
                                    onClick={() =>
                                      this.setState({
                                        resendEmail: row?.guest_employee_id,
                                        employee_name: row?.employee_name,
                                        candidateDesignation:
                                          row?.designation_title,
                                        candidateDepartment:
                                          row?.department_title,
                                        candidateGrade: row?.grade_title,
                                        candidateLocation: row?.location_title,
                                        employee_joining_date:
                                          row?.employee_joining_date,
                                      })
                                    }
                                    className="btn-icon btn btn-sm btn-outline-danger"
                                  >
                                    <i className="ri-mail-close-line"></i>
                                  </button>
                                  </TooltipComponent> */}
                                  { this.state.decodedData?.includes(3) && (
                                  <IconButton 
                                    onClick={() => {
                                      this.setState({
                                        resendEmail: row?.guest_employee_id,
                                        employee_name: row?.employee_name,
                                        candidateDesignation:
                                          row?.designation_title,
                                        candidateDepartment:
                                          row?.department_title,
                                        candidateGrade: row?.grade_title,
                                        candidateLocation: row?.location_title,
                                        employee_joining_date:
                                          row?.employee_joining_date,
                                      });
                                        }} type='danger' icon='ri-mail-close-line' tooltipName='Send Offer Cancelation Email' tooltipPosition='bottom' />)}
                                </td>)}
                              </tr>
                            );
                          })}
                        </tbody>
                      )}
                      <tfoot className="table-light">
                        <tr>
                          <th colSpan={10}>
                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  this.state.prev === false &&
                                  this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handlePrev()}
                                className={`btn btn-warning btn-label waves-effect waves-light`}
                              >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                Previous
                              </button>
                              <div
                                className="col-md-4"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {
                                  <small>
                                    Total Records: {this.state.total_records} |
                                    Total Pages: {this.state.total_pages} |
                                    Current Page: {this.state.page}
                                  </small>
                                }
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={(e) => this.handleChange(e)}
                                >
                                  {Array.from(
                                    { length: this.state.total_pages },
                                    (_, i) => (
                                      <option
                                        selected={this.state.page === i + 1}
                                        key={i}
                                        value={i + 1}
                                      >
                                        Page {i + 1}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={this.handleLimitChange}
                                  value={this.state.limit}
                                >
                                 <option value={this.total_records}>All</option>
                                  {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                      Limit {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <button
                                disabled={
                                  this.state.next === false &&
                                  this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                              >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                Next
                              </button>
                            </div>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div>
                    {this.state.resendEmail && (
                      <div
                        id="myModal"
                        className="modal show"
                        tabIndex={-1}
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                      >
                        <div
                          className=" bg-light m-auto mt-3"
                          style={{ width: "80%" }}
                        >
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="myModalLabel">
                                Offer Cancel Email Template
                              </h5>

                              <button
                                onClick={() => {
                                  this.setState({
                                    resendEmail: false,
                                    isEmailModal: false,
                                    emailEdit: false,
                                    emailPreviewClicked: false,
                                    mailTemplateTitle:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_template_title,
                                    mailSubject:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_subject,
                                    mailBody:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_body,
                                    employee_name: "",
                                    candidateDesignation: "",
                                    candidateDepartment: "",
                                    candidateGrade: "",
                                    candidateLocation: "",
                                    employee_joining_date: "",
                                    emailList: false,
                                  });
                                }}
                                className="btn-close"
                                aria-label="Close"
                              ></button>
                            </div>
                            {!this.state.emailList ? (
                              <div className="modal-body">
                                <div className="row">
                                  <table
                                    className={`table table-bordered table-stripped`}
                                  >
                                    <thead className="table-light">
                                      <tr>
                                        <th>Select</th>
                                        <th>Sr.No.</th>
                                        <th width={`30%`}>Mail Title</th>
                                        <th width={`60%`}>Mail Subject</th>

                                        <th
                                          width={`10%`}
                                          className=" text-center"
                                        >
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.email_rows.map((row, idx) => {
                                        return (
                                          <tr key={row?.mail_template_id}>
                                            <td>
                                              <div className="d-flex justify-content-center align-items-center">
                                                <input
                                                  type="checkbox"
                                                  className="form-check-input"
                                                  checked={
                                                    this.state
                                                      .selectedEmailTemplate ==
                                                    row?.mail_template_id
                                                  }
                                                  onChange={() =>
                                                    this.setState({
                                                      selectedEmailTemplate:
                                                        row?.mail_template_id,
                                                    })
                                                  }
                                                />
                                              </div>
                                            </td>
                                            <td>{idx + 1}</td>
                                            <td>{row?.mail_template_title}</td>
                                            <td>{row?.mail_subject}</td>
                                            <td className="d-flex justify-content-around">
                                              {/* <button onClick={() => handleDelete(row?.mail_template_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button> */}
                                              {this.state.infoLoading ===
                                              row?.mail_template_id ? (
                                                <button className="btn btn-success btn-load">
                                                  <span className="d-flex align-items-center">
                                                    <span
                                                      className="spinner-border flex-shrink-0"
                                                      role="status"
                                                    >
                                                      <span className="visually-hidden">
                                                        Loading...
                                                      </span>
                                                    </span>
                                                    {/* <span className="flex-grow-1 ms-2">
                                                            Loading...
                                                            </span> */}
                                                  </span>
                                                </button>
                                              ) : (
                                                <button
                                                  className="btn-icon btn btn-sm btn-outline-success"
                                                  onClick={() =>
                                                    this.getInfo(
                                                      row?.mail_template_id,
                                                      idx
                                                    )
                                                  }
                                                >
                                                  {" "}
                                                  <i className="ri-file-info-line"></i>{" "}
                                                </button>
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                    <tfoot className="table-light">
                                      <tr>
                                        <th colSpan={7}>
                                          <div className="d-flex justify-content-between">
                                            <button
                                              disabled={
                                                this.state.email_prev ===
                                                  false &&
                                                this.state.loadingList === false
                                                  ? true
                                                  : false
                                              }
                                              type="button"
                                              onClick={() =>
                                                this.handlePrev("email")
                                              }
                                              className={`btn btn-warning btn-label waves-effect waves-light`}
                                            >
                                              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                              Previous
                                            </button>
                                            <div
                                              className="col-md-4"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              {
                                                <small>
                                                  Total Records:{" "}
                                                  {
                                                    this.state
                                                      .email_total_records
                                                  }{" "}
                                                  | Total Pages:{" "}
                                                  {this.state.email_total_pages}{" "}
                                                  | Current Page:{" "}
                                                  {this.state.email_page}
                                                </small>
                                              }
                                            </div>
                                            <div className="col-md-2">
                                              <select
                                                className="form-select"
                                                onChange={(e) =>
                                                  this.handleChange(e, "email")
                                                }
                                              >
                                                {Array.from(
                                                  {
                                                    length:
                                                      this.state
                                                        .email_total_pages,
                                                  },
                                                  (_, i) => (
                                                    <option
                                                      selected={
                                                        this.state
                                                          .email_page ===
                                                        i + 1
                                                      }
                                                      key={i}
                                                      value={i + 1}
                                                    >
                                                      Page {i + 1}
                                                    </option>
                                                  )
                                                )}
                                              </select>
                                            </div>
                                            <button
                                              disabled={
                                                this.state.email_next ===
                                                  false &&
                                                this.state.loadingList === false
                                                  ? true
                                                  : false
                                              }
                                              type="button"
                                              onClick={() =>
                                                this.handleNext("email")
                                              }
                                              className={`btn btn-primary btn-label waves-effect right waves-light`}
                                            >
                                              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                              Next
                                            </button>
                                          </div>
                                        </th>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            ) : (
                              <div className="modal-body">
                                <div className="">
                                  <div className="">
                                    <div className="card-body">
                                      {!this.state.emailEdit ? (
                                        <div>
                                          <div className="row gy-4">
                                            <div className="col-md-12 mb-1 mt-0">
                                              <label
                                                htmlFor="mailTemplateTitle"
                                                className="form-label"
                                              >
                                                Title:
                                              </label>
                                              <input
                                                type="text"
                                                id="mailTemplateTitle"
                                                name="mailTemplateTitle"
                                                disabled
                                                value={
                                                  this.state.email_rows[
                                                    parseInt(
                                                      this.state.isEmailModal
                                                    )
                                                  ]?.mail_template_title
                                                }
                                                // onChange={e => this.handleInputChange(e)}
                                                className={`form-control`}
                                                placeholder="Template Title"
                                              />
                                            </div>
                                            <div className="col-md-12 mb-0 mt-0">
                                              <label
                                                htmlFor="mailSubject"
                                                className="form-label"
                                              >
                                                Subject:
                                              </label>
                                              <input
                                                type="text"
                                                id="mailSubject"
                                                name="mailSubject"
                                                disabled
                                                value={
                                                  this.state.email_rows[
                                                    parseInt(
                                                      this.state.isEmailModal
                                                    )
                                                  ]?.mail_subject
                                                }
                                                // onChange={e =>
                                                //   this.handleInputChange(e)
                                                // }
                                                className={`form-control`}
                                                placeholder="Subject"
                                              />
                                            </div>
                                            <div className="col-md-12 mb-3 mt-0">
                                              <label
                                                htmlFor="mailSubject"
                                                className="form-label"
                                              >
                                                Body:
                                              </label>
                                              <div
                                                style={{
                                                  border: "1px solid gray",
                                                  backgroundColor: "#EFF2F7",
                                                  borderRadius: "10px",
                                                }}
                                                className=" px-3 py-2"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    this.state.email_rows[
                                                      parseInt(
                                                        this.state.isEmailModal
                                                      )
                                                    ]?.mail_body || "",
                                                }}
                                              />
                                            </div>
                                            <div>
                                              {!this.state.emailEdit ? (
                                                <button
                                                  style={{
                                                    marginRight: "10px",
                                                  }}
                                                  onClick={() => {
                                                    this.setState({
                                                      emailEdit: true,
                                                    });
                                                  }}
                                                  className="btn btn-warning"
                                                >
                                                  {"Edit"}
                                                </button>
                                              ) : (
                                                ""
                                              )}
                                              <button
                                                onClick={() => {
                                                  this.setState({
                                                    isEmailModal: false,
                                                    emailEdit: false,
                                                    emailPreviewClicked: false,
                                                    emailList: false,
                                                  });
                                                }}
                                                className="btn btn-light"
                                              >
                                                Back
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      ) : !this.state.emailPreviewClicked ? (
                                        <>
                                          <div className="d-flex justify-content-between align-items-center mb-3">
                                            <button
                                              type="button"
                                              className={`${
                                                this.state.mailBody
                                                  ? ""
                                                  : "d-none"
                                              } btn btn-primary btn-label mx-2`}
                                              onClick={() =>
                                                this.setState(
                                                  { emailPreviewClicked: true },
                                                  () => {
                                                    this.templatePreview(
                                                      "email"
                                                    );
                                                  }
                                                )
                                              } // Add onClick handler for preview button
                                            >
                                              Preview
                                              <i className="ri-eye-line label-icon align-middle fs-16" />
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-primary waves-effect right waves-light btn-label"
                                              data-bs-toggle="offcanvas"
                                              data-bs-target="#offcanvasRight"
                                              aria-controls="offcanvasRight"
                                            >
                                              <i className="ri-code-s-slash-line label-icon align-middle fs-16" />{" "}
                                              Placeholder Keys
                                            </button>
                                          </div>
                                          <div
                                            className="offcanvas offcanvas-end"
                                            tabIndex={-1}
                                            id="offcanvasRight"
                                            aria-labelledby="offcanvasRightLabel"
                                          >
                                            <div className="offcanvas-header">
                                              <h5 id="offcanvasRightLabel">
                                                {" "}
                                                Placeholder Keys
                                              </h5>
                                              <button
                                                type="button"
                                                className="btn-close text-reset"
                                                data-bs-dismiss="offcanvas"
                                                aria-label="Close"
                                              />
                                            </div>

                                            <div className="offcanvas-body">
                                              <table class="table table-hover table-bordered border-primary table-nowrap">
                                                <thead className="bg-primary text-light bg-gradient">
                                                  <tr>
                                                    <th scope="col">Names</th>
                                                    <th scope="col">Code</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    <td>Current Date</td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##current_date##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##current_date##
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>URL</td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##accept_reject_link##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##current_date##
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Employee Name</td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##employee_name##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##employee_name##
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Department Title</td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##department_title##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##department_title##
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Designation Title</td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##designation_title##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##designation_title##
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Grade Title</td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##grade_title##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##grade_title##
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>Location Title</td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##location_title##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##location_title##
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <td>
                                                      Employee Joining Date
                                                    </td>
                                                    <td
                                                      onClick={() =>
                                                        this.handleCopyClick(
                                                          "##employee_joining_date##"
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      ##employee_joining_date##
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                          <form
                                            className=" mt-3"
                                            onSubmit={() => this.handleEmail()}
                                          >
                                            <div className="row gy-4">
                                              <div className="col-md-12 mb-1 mt-3">
                                                <label
                                                  htmlFor="mailTemplateTitle"
                                                  className="form-label"
                                                >
                                                  Title:
                                                </label>
                                                <input
                                                  type="text"
                                                  id="mailTemplateTitle"
                                                  name="mailTemplateTitle"
                                                  value={
                                                    this.state.mailTemplateTitle
                                                  }
                                                  disabled
                                                  onChange={(e) =>
                                                    this.handleEmailInputChange(
                                                      e
                                                    )
                                                  }
                                                  className={`form-control ${
                                                    this.state.errors
                                                      .mailTemplateTitle
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  placeholder="Enter Template Title"
                                                />

                                                {this.state.errors
                                                  .mailTemplateTitle && (
                                                  <div className="invalid-feedback">
                                                    {
                                                      this.state.errors
                                                        .mailTemplateTitle
                                                    }
                                                  </div>
                                                )}
                                              </div>
                                              <div className="col-md-12 mb-3 mt-0">
                                                <label
                                                  htmlFor="mailSubject"
                                                  className="form-label"
                                                >
                                                  Subject:
                                                </label>
                                                <input
                                                  type="text"
                                                  id="mailSubject"
                                                  name="mailSubject"
                                                  value={this.state.mailSubject}
                                                  disabled
                                                  onChange={(e) =>
                                                    this.handleEmailInputChange(
                                                      e
                                                    )
                                                  }
                                                  className={`form-control ${
                                                    this.state.errors
                                                      .mailSubject
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  placeholder="Enter Subject"
                                                />

                                                {this.state.errors
                                                  .mailSubject && (
                                                  <div className="invalid-feedback">
                                                    {
                                                      this.state.errors
                                                        .mailSubject
                                                    }
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                            <div className="col-md-12">
                                              <CKEditor
                                                editor={ClassicEditor}
                                                data={this.state.mailBody}
                                                name={"mailBody"}
                                                onChange={
                                                  this.handleEditorEmailChange
                                                }
                                              />
                                              {this.state.errors.mailBody && (
                                                <div
                                                  style={{ fontSize: "12px" }}
                                                  className=" text-danger"
                                                >
                                                  {this.state.errors.mailBody}
                                                </div>
                                              )}
                                              <div
                                                style={{
                                                  marginTop: "30px",
                                                  marginLeft: "Auto",
                                                }}
                                              >
                                                <button
                                                  // disabled={loading}
                                                  style={{
                                                    marginRight: "10px",
                                                  }}
                                                  type="submit"
                                                  className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                >
                                                  <i
                                                    className={`ri-save-line label-icon align-middle fs-16 ms-2`}
                                                  />
                                                  {"Save"}
                                                </button>
                                                <button
                                                  onClick={() =>
                                                    this.setState({
                                                      emailEdit: false,
                                                      emailList: false,
                                                    })
                                                  }
                                                  className={`btn btn-danger btn-label waves-effect right waves-light float-right`}
                                                >
                                                  <i
                                                    className={`ri-save-line label-icon align-middle fs-16 ms-2`}
                                                  />
                                                  {"Cancel"}
                                                </button>
                                              </div>
                                            </div>
                                          </form>
                                        </>
                                      ) : (
                                        <div>
                                          <div className="row gy-4">
                                            <div>
                                              <button
                                                onClick={() => {
                                                  this.setState({
                                                    emailPreviewClicked: false,
                                                  });
                                                }}
                                                className="btn btn-warning"
                                              >
                                                {"Editor"}
                                              </button>
                                            </div>
                                            <div className="col-md-12 mb-1 mt-0">
                                              <label
                                                htmlFor="mailTemplateTitle"
                                                className="form-label"
                                              >
                                                Title:
                                              </label>
                                              <input
                                                type="text"
                                                id="mailTemplateTitle"
                                                name="mailTemplateTitle"
                                                disabled
                                                value={
                                                  this.state.email_rows[
                                                    parseInt(
                                                      this.state.isEmailModal
                                                    )
                                                  ]?.mail_template_title
                                                }
                                                // onChange={e => this.handleInputChange(e)}
                                                className={`form-control`}
                                                placeholder="Template Title"
                                              />
                                            </div>
                                            <div className="col-md-12 mb-0 mt-0">
                                              <label
                                                htmlFor="mailSubject"
                                                className="form-label"
                                              >
                                                Subject:
                                              </label>
                                              <input
                                                type="text"
                                                id="mailSubject"
                                                name="mailSubject"
                                                disabled
                                                value={
                                                  this.state.email_rows[
                                                    parseInt(
                                                      this.state.isEmailModal
                                                    )
                                                  ]?.mail_subject
                                                }
                                                // onChange={e =>
                                                //   this.handleInputChange(e)
                                                // }
                                                className={`form-control`}
                                                placeholder="Subject"
                                              />
                                            </div>
                                            <div className="col-md-12 mb-3 mt-0">
                                              <label
                                                htmlFor="mailSubject"
                                                className="form-label"
                                              >
                                                Body:
                                              </label>
                                              <div
                                                style={{
                                                  border: "1px solid gray",
                                                  backgroundColor: "#EFF2F7",
                                                  borderRadius: "10px",
                                                }}
                                                className=" px-3 py-2"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    this.state.email_preview ||
                                                    "",
                                                }}
                                              />
                                            </div>
                                            <div>
                                              {!this.state.emailEdit ? (
                                                <button
                                                  onClick={() => {
                                                    this.setState({
                                                      emailEdit: true,
                                                    });
                                                  }}
                                                  className="btn btn-warning"
                                                >
                                                  {"Editor"}
                                                </button>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="modal-footer">
                              {this.state.selectedEmailTemplate ? (
                                <button
                                  type="submit"
                                  className="btn btn-danger btn-label ms-auto waves-effect waves-light"
                                  onClick={() => {
                                    this.handleCancelEmail(
                                      this.state.resendEmail
                                    );
                                  }}
                                >
                                  <i className="ri-mail-close-line label-icon align-middle fs-16 me-2" />
                                  Send
                                </button>
                              ) : null}

                              <button
                                onClick={() => {
                                  this.setState({
                                    resendEmail: false,
                                    mailTemplateTitle:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_template_title,
                                    mailSubject:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_subject,
                                    mailBody:
                                      this.state.email_rows[
                                        parseInt(this.state.isEmailModal)
                                      ]?.mail_body,
                                    isEmailModal: false,
                                    emailEdit: false,
                                    emailPreviewClicked: false,
                                    employee_name: "",
                                    candidateDesignation: "",
                                    candidateDepartment: "",
                                    candidateGrade: "",
                                    candidateLocation: "",
                                    employee_joining_date: "",
                                    emailList: false,
                                  });
                                }}
                                className="btn btn-light"
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.viewOfferLetterInfo ? (
                      <div
                        id="myModal"
                        className="modal show"
                        tabIndex={-1}
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                      >
                        <div
                          className=" bg-light m-auto mt-3"
                          style={{ width: "80%" }} // Custom width for the modal
                        >
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title" id="myModalLabel">
                                Offer Letter Info
                              </h5>
                              <button
                                onClick={() => {
                                  this.setState({
                                    viewOfferLetterInfo: false,
                                    candidateRemarks: '',
                                    employee_name: '',
                                    candidateDesignation:'',
                                    candidateDepartment:'',
                                    candidateGrade: '',
                                    candidateLocation:'',
                                    employee_joining_date:'',
                                  });
                                }}
                                className="btn-close"
                                aria-label="Close"
                              ></button>
                            </div>
                            <div className="modal-body"></div>
                            <div className="modal-footer">
                              <button
                                onClick={() => {
                                  this.setState({
                                    viewOfferLetterInfo: false,
                                  });
                                }}
                                className="btn btn-light"
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                    {this.state.viewOfferLetterLogs ? (
                      <div
                        id="myModal"
                        className="modal show"
                        tabIndex={-1}
                        style={{
                          display: "block",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                      >
                        <div
                          className=" bg-light m-3"
                          style={{ width: "98%" }} // Custom width for the modal
                        >
                          <div className="modal-content">
                            <div className="">
                              <div className="card-header d-flex justify-content-between align-items-center">
                                <h4 className="card-title mb-0">
                                  Offer Letter Logs
                                </h4>
                                <button
                                  onClick={() => {
                                    this.setState({
                                      viewOfferLetterInfo: false,
                                      viewOfferLetterLogs: false,
                                      candidateRemarks: ''
                                    });
                                  }}
                                  className="btn-close"
                                  aria-label="Close"
                                ></button>
                              </div>
                            </div>
                            <div className="modal-body">
                              <div className="card-body form-steps">
                                <div className="vertical-navs-step">
                                  <div className="row gy-5">
                                    <div className="col-md-2">
                                      <div className="nav d-flex">
                                        <button
                                          className="nav-link active"
                                          id="v-pills-bill-info-tab"
                                          data-bs-toggle="pill"
                                          data-bs-target="#v-pills-bill-info"
                                          type="button"
                                          role="tab"
                                          aria-controls="v-pills-bill-info"
                                          aria-selected="true"
                                        >
                                          <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                            Step 1
                                          </span>
                                          Candidate Details
                                        </button>
                                        <button
                                          className="nav-link"
                                          id="v-pills-bill-address-tab"
                                          data-bs-toggle="pill"
                                          data-bs-target="#v-pills-bill-address"
                                          type="button"
                                          role="tab"
                                          aria-controls="v-pills-bill-address"
                                          aria-selected="false"
                                        >
                                          <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                            Step 2
                                          </span>
                                          Salary Details
                                        </button>
                                        <button
                                          className="nav-link"
                                          id="v-pills-finish-tab"
                                          data-bs-toggle="pill"
                                          data-bs-target="#v-pills-finish"
                                          type="button"
                                          role="tab"
                                          aria-controls="v-pills-finish"
                                          aria-selected="false"
                                        >
                                          <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                            Step 3
                                          </span>
                                          Letter Details
                                        </button>
                                        <button
                                          className="nav-link"
                                          id="v-pills-email-tab"
                                          data-bs-toggle="pill"
                                          data-bs-target="#v-pills-email"
                                          type="button"
                                          role="tab"
                                          aria-controls="v-pills-email"
                                          aria-selected="false"
                                        >
                                          <span className="step-title me-2">
                                            <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                            Step 4
                                          </span>
                                          Email Details
                                        </button>
                                        
                                           <button
                                           className="nav-link"
                                           id="v-pills-remarks-tab"
                                           data-bs-toggle="pill"
                                           data-bs-target="#v-pills-remarks"
                                           type="button"
                                           role="tab"
                                           aria-controls="v-pills-remarks"
                                           aria-selected="false"
                                         >
                                           <span className="step-title me-2">
                                             <i className="ri-close-circle-fill step-icon me-2" />{" "}
                                             Step 5
                                           </span>
                                           Candidate Remark
                                         </button>
                                        
                                     
                                      </div>
                                    </div>
                                    <div className="col-lg-10">
                                      <div className="px-lg-4">
                                      
                                        <div className="tab-content">
                                          {/* Candidate Details */}
                                          <div
                                            className="tab-pane fade show active"
                                            id="v-pills-bill-info"
                                            role="tabpanel"
                                            aria-labelledby="v-pills-bill-info-tab"
                                          >
                                           
                                            <h5>Personal Details</h5>
                                            <div className="row">
                                              <table
                                                className={`table table-bordered table-hover`}
                                              >
                                                <thead className="table-light">
                                                  <tr>
                                                    <th>Sr.No.</th>
                                                    <th>Issued Date</th>
                                                    <th>Name</th>
                                                    <th>Mobile No.</th>
                                                    <th>Personal Email</th>
                                                    <th>Location</th>
                                                    <th>Department</th>
                                                    <th>Designation</th>
                                                    {/* <th className=' text-center'>Action</th> */}
                                                  </tr>
                                                </thead>
                                                {this.state.logs_details_rows?.employee_basic_details
                                                  ?.length === 0 ? (
                                                  <tbody>
                                                    <tr>
                                                      <td colSpan={12}>
                                                        <NoRecords />
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                ) : (
                                                  <tbody>
                                                    {this.state.logs_details_rows?.employee_basic_details?.map(
                                                      (row, idx) => {
                                                        return (
                                                          <tr
                                                            key={
                                                              row?.company_letter_id
                                                            }
                                                          >
                                                            <td>{idx + 1}</td>
                                                            <td>
                                                              {row?.log_date
                                                                ? formatDateWithTime(
                                                                    row?.log_date
                                                                  )
                                                                : "--"}
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.employee_name
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.employee_mobile_number
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.employee_email_address
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.location_title
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.department_title
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.designation_title
                                                              }
                                                            </td>
                                                            {/* <td><button onClick={() => this.setState({ infoLoading: true }, () => { this.GetLetterInfo(idx) })} className="btn-icon btn btn-sm btn-outline-success"> <i className="ri-file-info-line"></i> </button></td> */}
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </tbody>
                                                )}
                                              </table>
                                            </div>
                                          </div>
                                          {/* Salary Details */}
                                          <div
                                            className="tab-pane fade"
                                            id="v-pills-bill-address"
                                            role="tabpanel"
                                            aria-labelledby="v-pills-bill-address-tab"
                                          >
                                            <div>
                                              <div className="row g-3">
                                                <div>
                                                  <h5>Salary Details</h5>
                                                </div>
                                                <h6 className=" mt-1">{(this.state.logs_details_rows?.salary_log_data?.length > 0) && (this.state.logs_details_rows?.salary_log_data[0]?.log_date)
                                                      ? formatDateWithTime(this.state.logs_details_rows?.salary_log_data[0]?.log_date)
                                                  : ""}</h6>
                                                <div className=" mt-1">
                                                  <table
                                                    className="table table-nowrap table-sm "
                                                    style={{
                                                      marginBottom: "50px",
                                                    }}
                                                  >
                                                    <thead className="table-light ">
                                                      <tr>
                                                        <th scope="col">
                                                          Sr.No.
                                                        </th>
                                                        {/* <th scope="col">
                                                          Sent Date
                                                        </th> */}
                                                        <th scope="col">
                                                          Allowance Type
                                                        </th>
                                                        <th scope="col">
                                                          Amount
                                                        </th>
                                                        {/* <th scope='col'>Action</th> */}
                                                      </tr>
                                                    </thead>
                                                    {this.state.logs_details_rows?.salary_log_data?.length === 0 ? (
                                                      <tbody>
                                                        <tr>
                                                          <td colSpan={12}>
                                                            <NoRecords />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    ) : (
                                                      <tbody>
                                                        {this.state.logs_details_rows?.salary_log_data?.map((allowance,index) => (
                                                            <tr key={index}>
                                                              <td>
                                                                {index + 1}
                                                              </td>
                                                              {/* <td>
                                                                {allowance?.log_date
                                                                  ? formatDateWithTime(
                                                                      allowance?.log_date
                                                                    )
                                                                  : "--"}
                                                              </td> */}
                                                              <td>
                                                                {
                                                                  allowance?.company_salary_head
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  allowance?.company_salary_head_value
                                                                }
                                                              </td>
                                                              {/* <td>
                                                                        <button
                                                                        type='button'
                                                                        className='btn btn-link text-danger fs-15'
                                                                        onClick={() =>
                                                                            this.handleDeleteAllowance(
                                                                            index
                                                                            )
                                                                        }
                                                                        >
                                                                        <i className='ri-delete-bin-line' />
                                                                        </button>
                                                                    </td> */}
                                                            </tr>
                                                          )
                                                        )}
                                                      </tbody>
                                                    )}
                                                    {/* <tfoot className="table-light">
                                                      <tr>
                                                        <th
                                                          scope="rowgroup"
                                                          colSpan="1"
                                                        ></th>
                                                        <th
                                                          scope="rowgroup"
                                                          colSpan="1"
                                                        >
                                                          CTC
                                                        </th>
                                                        <th
                                                          scope="rowgroup"
                                                          colSpan="1"
                                                        >
                                                          {this.state
                                                            .logs_details_rows
                                                            ?.salary_log_data
                                                            ?.length > 0 &&
                                                            this.state.logs_details_rows?.salary_log_data
                                                              .reduce(
                                                                (
                                                                  total,
                                                                  allowance
                                                                ) =>
                                                                  total +
                                                                  parseFloat(
                                                                    allowance.company_salary_head_value
                                                                  ),
                                                                0
                                                              )
                                                              .toFixed(2)}
                                                        </th>
                                                        <th
                                                          scope="rowgroup"
                                                          colSpan="1"
                                                        ></th>
                                                      </tr>
                                                    </tfoot> */}
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          {/* Letter Details */}
                                          <div
                                            className="tab-pane fade"
                                            id="v-pills-finish"
                                            role="tabpanel"
                                            aria-labelledby="v-pills-finish-tab"
                                          >
                                            <div>
                                              <h5>Letter Details</h5>
                                            </div>
                                            <div className="row">
                                              <table
                                                className={`table table-bordered table-hover`}
                                              >
                                                <thead className="table-light">
                                                  <tr>
                                                    <th>Sr.No.</th>
                                                    <th>Issued Date</th>
                                                    <th>Letter Lists</th>
                                                    <th
                                                      width={`10%`}
                                                      className=" text-center"
                                                    >
                                                      Action
                                                    </th>
                                                  </tr>
                                                </thead>

                                                {this.state.logs_details_rows
                                                  ?.employee_letter_details
                                                  ?.length === 0 ? (
                                                  <tbody>
                                                    <tr>
                                                      <td colSpan={12}>
                                                        <NoRecords />
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                ) : (
                                                  <tbody>
                                                    {this.state.logs_details_rows?.employee_letter_details?.map(
                                                      (row, idx) => {
                                                        return (
                                                          <tr
                                                            key={
                                                              row?.company_letter_id
                                                            }
                                                          >
                                                            <td>{idx + 1}</td>
                                                            <td>
                                                              {row?.log_date
                                                                ? formatDateWithTime(
                                                                    row?.log_date
                                                                  )
                                                                : "--"}
                                                            </td>
                                                            <td>
                                                              {
                                                                row?.company_letter_title
                                                              }
                                                            </td>
                                                            <td>
                                                              <button
                                                                onClick={() =>
                                                                  this.setState(
                                                                    {
                                                                      infoLoading: true,
                                                                    },
                                                                    () => {
                                                                      this.GetLetterInfo(
                                                                        idx
                                                                      );
                                                                    }
                                                                  )
                                                                }
                                                                className="btn-icon btn btn-sm btn-outline-success"
                                                              >
                                                                {" "}
                                                                <i className="ri-file-info-line"></i>{" "}
                                                              </button>
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </tbody>
                                                )}

                                                {/* <tfoot className="table-light">
                                                                <tr>
                                                                    <th colSpan={7}>
                                                                    <div className="d-flex justify-content-between">
                                                                        <button
                                                                        disabled={
                                                                            this.state.letter_prev === false &&
                                                                            this.state.loadingList === false
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        type="button"
                                                                        onClick={() => this.handlePrev("letter")}
                                                                        className={`btn btn-warning btn-label waves-effect waves-light`}
                                                                        >
                                                                        <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                                        Previous
                                                                        </button>
                                                                        <div
                                                                        className="col-md-4"
                                                                        style={{ display: "flex", alignItems: "center" }}
                                                                        >
                                                                        {
                                                                            <small>
                                                                            Total Records: {this.state.letter_total_records} |
                                                                            Total Pages: {this.state.letter_total_pages} |
                                                                            Current Page: {this.state.letter_page}
                                                                            </small>
                                                                        }
                                                                        </div>
                                                                        <div className="col-md-2">
                                                                        <select
                                                                            className="form-select"
                                                                            onChange={(e) => this.handleChange(e,"letter")}
                                                                        >
                                                                            {Array.from(
                                                                            { length: this.state.letter_total_pages },
                                                                            (_, i) => (
                                                                                <option
                                                                                selected={this.state.letter_page === i + 1}
                                                                                key={i}
                                                                                value={i + 1}
                                                                                >
                                                                                Page {i + 1}
                                                                                </option>
                                                                            )
                                                                            )}
                                                                        </select>
                                                                        </div>
                                                                        <button
                                                                        disabled={
                                                                            this.state.letter_next === false &&
                                                                            this.state.loadingList === false
                                                                            ? true
                                                                            : false
                                                                        }
                                                                        type="button"
                                                                        onClick={() =>{ this.handleNext("letter")}}
                                                                        className={`btn btn-primary btn-label waves-effect right waves-light`}
                                                                        >
                                                                        <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                                        Next
                                                                        </button>
                                                                    </div>
                                                                    </th>
                                                                </tr>
                                                                </tfoot> */}
                                              </table>
                                            </div>
                                            {this.state.isLetterModal && (
                                              <div
                                                id="myModal"
                                                className="modal show"
                                                tabIndex={-1}
                                                style={{
                                                  display: "block",
                                                  backgroundColor:
                                                    "rgba(0, 0, 0, 0.5)",
                                                }}
                                                aria-labelledby="myModalLabel"
                                                aria-hidden="true"
                                              >
                                                <div className="modal-dialog modal-lg">
                                                  <div className="modal-content">
                                                    <div className="modal-header">
                                                      <h5
                                                        className="modal-title"
                                                        id="myModalLabel"
                                                      >
                                                        Letter Template
                                                      </h5>

                                                      <button
                                                        onClick={() => {
                                                          this.setState({
                                                            isLetterModal: false,
                                                            letterEdit: false,
                                                            previewClicked: false,
                                                          });
                                                        }}
                                                        className="btn-close"
                                                        aria-label="Close"
                                                      ></button>
                                                    </div>
                                                    <div className="modal-body">
                                                      <div className="">
                                                        <div className="mt-3">
                                                          <div className="">
                                                            <div>
                                                              <div className="card-body">
                                                                <h5 className=" py-1 px-4">
                                                                  Letter Title:{" "}
                                                                  {
                                                                    this.state
                                                                      .company_letter_title
                                                                  }
                                                                </h5>
                                                                {/* <h5 className=' py-2 px-4'></h5> */}
                                                                {this.state
                                                                  .company_letter_content &&
                                                                this.state
                                                                  .letterhead_url ? (
                                                                  renderPages(
                                                                    this.state
                                                                      .company_letter_content,
                                                                    this.state
                                                                      .letterhead_url,
                                                                    this.state
                                                                      .markings
                                                                  )
                                                                ) : (
                                                                  <h4 className="text-muted">
                                                                    No Preview
                                                                    available.
                                                                  </h4>
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                      <button
                                                        onClick={() => {
                                                          this.setState({
                                                            isLetterModal: false,
                                                            letterEdit: false,
                                                            previewClicked: false,
                                                          });
                                                        }}
                                                        className="btn btn-light"
                                                      >
                                                        Close
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                           {/* Email Details */}
                                        <div
                                          className="tab-pane fade"
                                          id="v-pills-email"
                                          role="tabpanel"
                                          aria-labelledby="v-pills-email-tab"
                                        >
                                          <div>
                                            <h5>
                                              Email Details{" "}
                                              <span
                                                style={{
                                                  color: "blue",
                                                  borderRadius: "50%",
                                                  background: "#f0f8ff",
                                                  padding: "2px 6px",
                                                  display: "inline-block",
                                                  textAlign: "center",
                                                  width: "20px",
                                                  height: "20px",
                                                  lineHeight: "20px",
                                                }}
                                              >
                                                *
                                              </span>
                                            </h5>
                                            <p className="text-muted">
                                              Fill all information below
                                            </p>
                                          </div>
                                          <div className="row">
                                            <table
                                              className={`table table-bordered table-stripped`}
                                            >
                                              <thead className="table-light">
                                                <tr>
                                                  <th>Sr.No.</th>
                                                  <th>Issued Date</th>
                                                  <th width={`30%`}>
                                                    Mail Title
                                                  </th>
                                                  <th width={`30%`}>
                                                    Mail Subject
                                                  </th>

                                                  <th
                                                    width={`10%`}
                                                    className=" text-center"
                                                  >
                                                    Action
                                                  </th>
                                                </tr>
                                              </thead>

                                              {this.state.logs_details_rows
                                                ?.employee_mail_details
                                                ?.length === 0 ? (
                                                <tbody>
                                                  <tr>
                                                    <td colSpan={12}>
                                                      <NoRecords />
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              ) : (
                                                <tbody>
                                                  {this.state.logs_details_rows?.employee_mail_details?.map(
                                                    (row, idx) => {
                                                      return (
                                                        <tr
                                                          key={
                                                            row?.mail_template_id
                                                          }
                                                        >
                                                          <td>{idx + 1}</td>
                                                          <td>
                                                            {row?.log_date
                                                              ? formatDateWithTime(
                                                                  row?.log_date
                                                                )
                                                              : "--"}
                                                          </td>
                                                          <td>
                                                            {
                                                              row?.mail_template_title
                                                            }
                                                          </td>
                                                          <td>
                                                            {row?.email_subject}
                                                          </td>
                                                          <td className="d-flex justify-content-around">
                                                            <button
                                                              onClick={() =>
                                                                this.setState(
                                                                  {
                                                                    infoLoading:
                                                                      row?.mail_template_id,
                                                                  },
                                                                  () => {
                                                                    this.getEmailInfo(
                                                                      row?.mail_template_id,
                                                                      idx
                                                                    );
                                                                  }
                                                                )
                                                              }
                                                              className="btn-icon btn btn-sm btn-outline-success"
                                                            >
                                                              {" "}
                                                              <i className="ri-file-info-line"></i>{" "}
                                                            </button>
                                                          </td>
                                                        </tr>
                                                      );
                                                    }
                                                  )}
                                                </tbody>
                                              )}
                                            </table>
                                          </div>
                                          {this.state.isEmailModal && (
                                            <div
                                              id="myModal"
                                              className="modal show"
                                              tabIndex={-1}
                                              style={{
                                                display: "block",
                                                backgroundColor:
                                                  "rgba(0, 0, 0, 0.5)",
                                              }}
                                              aria-labelledby="myModalLabel"
                                              aria-hidden="true"
                                            >
                                              <div className="modal-dialog modal-lg">
                                                <div className="modal-content">
                                                  <div className="modal-header">
                                                    <h5
                                                      className="modal-title"
                                                      id="myModalLabel"
                                                    >
                                                      Email Template
                                                    </h5>

                                                    <button
                                                      onClick={() => {
                                                        this.setState({
                                                          isEmailModal: false,
                                                          emailEdit: false,
                                                          emailPreviewClicked: false,
                                                          mailTemplateTitle:
                                                            this.state
                                                              .email_rows[
                                                              parseInt(
                                                                this.state
                                                                  .isEmailModal
                                                              )
                                                            ]
                                                              ?.mail_template_title,
                                                          mailSubject:
                                                            this.state
                                                              .email_rows[
                                                              parseInt(
                                                                this.state
                                                                  .isEmailModal
                                                              )
                                                            ]?.mail_subject,
                                                          mailBody:
                                                            this.state
                                                              .email_rows[
                                                              parseInt(
                                                                this.state
                                                                  .isEmailModal
                                                              )
                                                            ]?.mail_body,
                                                        });
                                                      }}
                                                      className="btn-close"
                                                      aria-label="Close"
                                                    ></button>
                                                  </div>
                                                  <div className="modal-body">
                                                    <div className="">
                                                      <div className="">
                                                        <div className="card-body">
                                                          <div>
                                                            <div className="row gy-4">
                                                              <div className="col-md-12 mb-1 mt-0">
                                                                <label
                                                                  htmlFor="mailTemplateTitle"
                                                                  className="form-label"
                                                                >
                                                                  Title:
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  id="mailTemplateTitle"
                                                                  name="mailTemplateTitle"
                                                                  disabled
                                                                  value={
                                                                    this.state
                                                                      .mailTemplateTitle
                                                                  }
                                                                  className={`form-control`}
                                                                  placeholder="Template Title"
                                                                />
                                                              </div>
                                                              <div className="col-md-12 mb-0 mt-0">
                                                                <label
                                                                  htmlFor="mailSubject"
                                                                  className="form-label"
                                                                >
                                                                  Subject:
                                                                </label>
                                                                <input
                                                                  type="text"
                                                                  id="mailSubject"
                                                                  name="mailSubject"
                                                                  disabled
                                                                  value={
                                                                    this.state
                                                                      .mailSubject
                                                                  }
                                                                  className={`form-control`}
                                                                  placeholder="Subject"
                                                                />
                                                              </div>
                                                              <div className="col-md-12 mb-3 mt-0">
                                                                <label
                                                                  htmlFor="mailSubject"
                                                                  className="form-label"
                                                                >
                                                                  Body:
                                                                </label>
                                                                <div
                                                                  style={{
                                                                    border:
                                                                      "1px solid gray",
                                                                    backgroundColor:
                                                                      "#EFF2F7",
                                                                    borderRadius:
                                                                      "10px",
                                                                  }}
                                                                  className=" px-3 py-2"
                                                                  dangerouslySetInnerHTML={{
                                                                    __html:
                                                                      this.state
                                                                        .mailBody ||
                                                                      "",
                                                                  }}
                                                                />
                                                              </div>
                                                              <div></div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="modal-footer">
                                                    <button
                                                      onClick={() => {
                                                        this.setState({
                                                          isEmailModal: false,
                                                          emailEdit: false,
                                                          emailPreviewClicked: false,
                                                        });
                                                      }}
                                                      className="btn btn-light"
                                                    >
                                                      Close
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                          {/* Candidate remarks */}
                                          
                                            <div
                                              className="tab-pane fade"
                                              id="v-pills-remarks"
                                              role="tabpanel"
                                              aria-labelledby="v-pills-remarks-tab"
                                            >
                                                 <h5 className="border-bottom pb-2">
                                                  Candidate Remark
                                                </h5>
                                                <div className="row p-3 mx-2 rounded-3 border border-light">
                                                  <div className="text-muted">{this.state.candidateRemarks? this.state.candidateRemarks:'No Remark!'}</div>
                                                </div>
                                            </div>
                                     
                                        </div>
                                       
                                      </div>
                                      {/* end tab content */}
                                    </div>
                                  </div>
                                  {/* end col */}
                                </div>
                                {/* end row */}
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              onClick={() => {
                                this.setState({
                                  viewOfferLetterInfo: false,
                                  viewOfferLetterLogs: false,
                                  candidateRemarks:''
                                });
                              }}
                              className="btn btn-light"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(OfferLetterSentList);
